import React from 'react'
import { useTranslation } from 'react-i18next'
import { Package } from 'lucide-react'
import useCrashStore from '../store/useCrashStore'

/**
 * Карточка выигранного в краше предмета (§5a: crash:win-skin).
 *
 * Показывается, когда crash:win-skin пришёл со skin != null для СВОЕЙ ставки.
 * skin.cost равен сумме выигрыша (win), не рыночной цене — не сверяем с магазином.
 *
 * skin: null — предмет не подобрался, выплатили кристаллами; отдельное состояние.
 * Здесь рисуем только положительный исход (предмет).
 */
const CrashWinSkin = ({ skin }) => {
  const { t } = useTranslation()
  if (!skin) return null

  return (
    <div className="flex items-center gap-3 p-3 rounded-xl bg-accent-primary/10 border border-accent-primary/30">
      <div
        className="shrink-0 w-14 h-14 rounded-lg overflow-hidden border-2"
        style={{ borderColor: skin.color || '#4b69ff' }}
      >
        {skin.img ? (
          <img src={skin.img} alt={skin.name || ''} className="w-full h-full object-cover" loading="lazy" />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-dark-secondary">
            <Package className="w-5 h-5 text-text-secondary" />
          </div>
        )}
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-xs text-text-secondary mb-0.5">
          {t('crash.winSkin.won')}
        </div>
        <div className="text-sm font-bold truncate" style={{ color: skin.color || '#fff' }}>
          {skin.name}
        </div>
        <div className="text-xs text-accent-primary font-semibold tabular-nums">
          {Number(skin.cost || 0).toLocaleString('ru-RU')}
        </div>
      </div>
    </div>
  )
}

/**
 * Плашка «Подбираем предмет» — пока ждём crash:win-skin для своей ставки со скинами.
 * Гасится по приходу события (skin заполнен или null) или по таймауту WIN_SKIN_TIMEOUT_MS.
 */
export const CrashPendingWinSkin = () => {
  const { t } = useTranslation()
  const pendingWinSkinChatIds = useCrashStore((s) => s.pendingWinSkinChatIds)
  const myChatId = useCrashStore((s) => s.myChatId)

  if (!myChatId || !pendingWinSkinChatIds.has(String(myChatId))) return null

  return (
    <div className="flex items-center gap-2 p-2.5 rounded-lg bg-info/10 border border-info/30">
      <div className="w-4 h-4 rounded-full border-2 border-info border-t-transparent animate-spin" />
      <span className="text-xs text-info font-medium">
        {t('crash.winSkin.picking')}
      </span>
    </div>
  )
}

export default CrashWinSkin
